import { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';

const KeywordRotator = ({ keywords, interval = 3000 }) => {
	// Use useRef for mutable variables that we want to persist
	// without triggering a re-render on their change
	const requestRef = useRef();
	const previousTimeRef = useRef();
	const timerRef = useRef(0);

	const [current, setCurrent] = useState(0);
	const [previous, setPrevious] = useState(null);
	const [isProgressActive, setIsProgressActive] = useState(false);

	useEffect(() => {
		const animate = (timestamp) => {
			if (previousTimeRef.current === undefined) {
				previousTimeRef.current = timestamp;
				// Set progress active after the first frame
				setIsProgressActive(true);
			}

			const deltaTime = timestamp - previousTimeRef.current;
			timerRef.current += deltaTime;

			// Check if we've reached the interval duration
			if (timerRef.current >= interval) {
				setPrevious(current);
				setCurrent((prev) => (prev + 1) % keywords.length);
				timerRef.current = 0; // Reset timer

				// Briefly disable progress while changing keywords
				setIsProgressActive(false);
				setTimeout(() => setIsProgressActive(true), 50);
			}

			previousTimeRef.current = timestamp;
			requestRef.current = requestAnimationFrame(animate);
		};

		requestRef.current = requestAnimationFrame(animate);

		// Cleanup function
		return () => {
			cancelAnimationFrame(requestRef.current);
			setIsProgressActive(false);
		};
	}, [current, keywords.length, interval]);

	return (
		<span
			className="kw-rotator"
			style={{ '--kw-rotator-interval': `${interval}ms` }}
		>
			{previous !== null && (
				<span key={`prev-${previous}`} className="kw kw-exit">
					{keywords[previous]}
				</span>
			)}
			<span
				key={`current-${current}`}
				className={classNames('kw', {
					'kw-progress': isProgressActive,
					'kw-enter': previous !== null,
				})}
			>
				{keywords[current]}
			</span>
		</span>
	);
};

export default KeywordRotator;
